import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import { translate as t } from '../../lib/I18n';
import OrderFare from '../../records/order/Fare';

import Icon from '../general/Icon';
import DateTime from '../general/DateTime';
import FareStations from './FareStations';
import PureRenderComponent from '../PureRenderComponent';


class FareShort extends PureRenderComponent {

    static propTypes = {
        orderFare: PropTypes.instanceOf(OrderFare).isRequired
    };

    _renderFareDate (text, journey, directionIcon) {
        if (!journey.legs.size) {
            return null;
        }
        return (
            <div key={ text } className="text-sm clearfix">
                <p className="direction no-margin text-light text-weight--normal">
                    <Icon icon="inbound" className={ directionIcon + ' text-light text-primary' } />
                    { t(text) + ' ' }
                    <DateTime
                        className="text-primary"
                        dateTime={ journey.getDepartureTime() }
                        format="HH:mm ddd DD MMM YYYY"
                    />
                </p>
            </div>
        );
    }

    _renderFareDates (fare) {
        let dates = [];
        const outwardJourney = fare.outwardJourney;
        const returnJourney = fare.returnJourney;

        dates.push(this._renderFareDate('order.summary.out', outwardJourney, 'otrl-rotate-180'));

        if (returnJourney) {
             dates.push(this._renderFareDate('order.summary.return', returnJourney, null));
        }

        return dates;
    }

    render () {
        const { orderFare } = this.props;

        return (
            <li className="order-summary__item order-summary__item--short margin-bottom">

                <Row className="fare-summary">
                    <Col xs={ 12 } md={ 6 } lg={ 6 }>
                        <FareStations
                            origin={ orderFare.origin }
                            destination={ orderFare.destination }
                            isReturn={ orderFare.isReturn() }
                        />
                    </Col>
                    <Col xs={ 12 } md={ 6 } lg={ 6 } className="text-weight--normal ticket-type no-margin">
                        <p className="text-weight--normal ticket-type no-margin">
                            { orderFare.getName() }&nbsp;
                            { orderFare.isGroupSave() && ( t('order.summary.groupSave') ) }
                        </p>
                    </Col>
                </Row>

                { this._renderFareDates(orderFare) }
            </li>
        );
    }

}


export default FareShort;



// WEBPACK FOOTER //
// ./src/components/checkout/FareShort.js